import { useEffect, useState } from "react";
import Draggable from "react-draggable";
import SpostIt from "./components/SpostIt";

const defaultNotes = [
  { id: 1, text: "Aggiornare la foto in homepage", color: "#fef08a", author: "Paco De Maria", userImage: "https://i.pravatar.cc/100?img=3", x: 70, y: 90, editing: false, pattern: "lines" },
  { id: 2, text: "Verificare link menu", color: "#bbf7d0", author: "Anna Rossi", userImage: "https://i.pravatar.cc/100?img=5", x: 390, y: 190, editing: false, pattern: "none" }
];

export default function SpostItPanel({ currentUser, permissions = [] }) {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState(() => {
    try { return JSON.parse(localStorage.getItem("spostit-notes")) || defaultNotes; }
    catch { return defaultNotes; }
  });
  const hasAll = currentUser?.role === "Superadmin" || permissions.includes("Tutte le funzioni");
  const canCreate = hasAll || permissions.includes("Crea");
  const canModify = hasAll || permissions.includes("Modifica");
  const canDelete = hasAll || permissions.includes("Elimina");
  useEffect(() => localStorage.setItem("spostit-notes", JSON.stringify(notes)), [notes]);
  useEffect(() => {
    const openPanel = () => setOpen(true);
    window.addEventListener("spostit:open", openPanel);
    return () => window.removeEventListener("spostit:open", openPanel);
  }, []);

  const change = (id, patch) => setNotes(prev => prev.map(note => note.id === id ? { ...note, ...patch } : note));
  const addNote = () => setNotes(prev => [...prev, { id: Date.now(), text: "Scrivi qui la tua idea…", color: "#fbcfe8", author: currentUser?.name || "Tu", userImage: currentUser?.avatar, x: 180 + prev.length * 18, y: 120 + prev.length * 16, editing: true, pattern: "none" }]);

  if (!open) return <button className="floating-launcher" onClick={() => setOpen(true)} aria-label="Apri SpostIt"><span>+</span></button>;
  return <div className="spostit-overlay">
    <div className="overlay-head"><div><strong>Bacheca SpostIt</strong><span>{notes.length} note nel workspace</span></div>{canCreate && <button className="add-note" onClick={addNote}>+ Nuovo SpostIt</button>}<button className="close-board" onClick={() => setOpen(false)} aria-label="Chiudi">×</button></div>
    <div className="board-hint">Trascina le note per organizzarle · doppio clic sul testo per modificarlo</div>
    {notes.map(note => <Draggable key={note.id} disabled={!canModify} position={{ x: note.x, y: note.y }} bounds="parent" cancel="button, textarea, input, label" onStop={(_, data) => change(note.id, { x: data.x, y: data.y })}><div className="drag-wrap"><SpostIt note={note} canModify={canModify} canDelete={canDelete} onChange={patch => change(note.id, patch)} onDelete={() => setNotes(prev => prev.filter(item => item.id !== note.id))} /></div></Draggable>)}
  </div>;
}
